// Shared avatar-or-fallback DOM toggle for live chat (chat-panel messages + the pinned-tips
// chip rail). `user` is the payload ChatSenderIdentity serializes (avatar_url, initials,
// avatar_color_class), so both surfaces render the exact same fallback AvatarComponent uses
// elsewhere in the app - no separate color/initials logic lives in JS.
export function applyAvatar(imgEl, fallbackEl, user) {
  const avatarUrl = user && user.avatar_url;

  if (avatarUrl) {
    if (imgEl) {
      imgEl.src = avatarUrl;
      imgEl.classList.remove("hidden");
    }
    if (fallbackEl) {
      fallbackEl.classList.add("hidden");
      fallbackEl.classList.remove("flex");
    }
    return;
  }

  if (imgEl) {
    imgEl.removeAttribute("src");
    imgEl.classList.add("hidden");
  }
  if (fallbackEl) {
    fallbackEl.textContent = (user && user.initials) || "";
    fallbackEl.classList.remove("hidden");
    fallbackEl.classList.add("flex");

    // fallbackEl may be a persistent element reused across renders (e.g. the chat-panel confirm
    // dialog's preview), not always a fresh template clone - drop whichever color class we
    // applied last time before adding the new one, so colors don't stack up across reuses.
    if (fallbackEl.dataset.avatarColorClass) fallbackEl.classList.remove(fallbackEl.dataset.avatarColorClass);
    if (user && user.avatar_color_class) {
      fallbackEl.classList.add(user.avatar_color_class);
      fallbackEl.dataset.avatarColorClass = user.avatar_color_class;
    } else {
      delete fallbackEl.dataset.avatarColorClass;
    }
  }
}
